import { useState } from "react"

const VideoModal = ({ isOpen, onClose, videoData }) => {
  const [isPlaying, setIsPlaying] = useState(false)

  if (!isOpen) return null
  const title = videoData.title;
  const description = videoData.description;
  const productName = videoData.productName;
  const videoUrlFinal  = videoData.videoUrlFinal;
  const fileName = videoData.fileName;
  const thumbnail = videoData.thumbnail;
  const uploadedTime = videoData.uploadedAt;
  const videoUrl = "./sampleVideo.mp4";
const  keywords  = videoData.eventKeywords.split(",").map(k => k.trim());

  const handlePlayVideo = () => {
    setIsPlaying(true)
  }

  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }
    return new Date(dateString).toLocaleDateString(undefined, options)
  }

  return (
    <div
      className={`modal fade ${isOpen ? "show d-block" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered modal-xl h-100" role="document">
        <div className="modal-content border-0 shadow-lg">
          <div className="modal-header border-bottom-0 bg-light">
            <h5 className="modal-title font-weight-bold">{title}</h5> &nbsp;&nbsp;<span className="badge bg-primary fs-6">{productName}</span>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
          </div>

          <div className="modal-body p-0">
            <div className="row g-0">
            <div 
  className="col-lg-8 bg-dark"  
  style={{
    height: '75vh', 
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'center', 
    alignItems: 'center'
  }}
>
  {isPlaying ? (
    <div className="ratio ratio-16x9 w-100 h-100">
      <video controls autoPlay src={videoUrlFinal} className="w-100 h-100" />
    </div>
  ) : (
    <div 
      className="position-relative w-100 h-100 d-flex justify-content-center align-items-center" 
      style={{ height: "100%" }} 
    >
      <img 
  src={`data:image/jpeg;base64,${thumbnail}`} 
  alt={title} 
  className="w-100 h-100"  
  style={{
    objectFit: "contain",  
    maxHeight: "66vh",  
    width: "90%",  
    height: "90%"  
  }}
/>


      {/* Play button */}
      <button
        className="btn btn-danger position-absolute top-50 start-50 translate-middle rounded-circle p-3"
        onClick={handlePlayVideo}
        style={{ width: "70px", height: "70px" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          fill="currentColor"
          className="bi bi-play-fill"
          viewBox="0 0 16 16"
        >
          <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z" />
        </svg>
      </button>
    </div>
  )}
</div>


              <div className="col-lg-4">
                <div className="p-4 h-100 d-flex flex-column">
                  <div className="mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                 
                      <small className="text-muted">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-clock me-1"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                          <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
                        </svg>
                        {formatDate(uploadedTime)}
                      </small>
                    </div>

                    <h6 className="text-uppercase text-muted small mb-2">Description</h6>
                    <div style={{maxHeight:'145px',minHeight:'145px',overflowY:'scroll'}}>
                    <p className="text-muted mb-4">{description}</p>
                    </div>
                    
                  </div>

                  <div className="mb-4">
                    <h6 className="text-uppercase text-muted small mb-2">Keywords</h6>
                    <div className="d-flex flex-wrap gap-2">
                      {keywords.map((keyword, index) => (
                        <span key={index} className="badge bg-light text-dark">
                          {keyword}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="mt-auto">
                    <h6 className="text-uppercase text-muted small mb-2">Filename</h6>
                    <div className="bg-light p-2 rounded">
                      <code className="small text-break">{fileName}</code>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer bg-light">
            <button type="button" className="btn btn-danger" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VideoModal

